export const THIRTY_SECOND_REST_PATH =
  "M154 455c79 0 46 -98 91 -98c15 0 46 49 52 63c6 13 23 12 28 0" +
  "l-216 -920c-8 -7 -18 -10 -28 -10s-19 3 -27 10l86 327c-35" +
  " -13 -71 -23 -108 -23c-47 0 -87 34 -87 79c0 40 32 72 72" +
  " 72c79 0 46 -98 91 -98c17 0 54 54 59 71l39 149c-34 -12" +
  " -70 -23 -106 -23c-47 0 -87 34 -87 79c0 40 33 72 73 72" +
  "c79 0 45 -98 90 -98c16 0 52 51 56 68l40 151c-33 -12 -68" +
  " -22 -103 -22c-47 0 -87 34 -87 79c0 40 32 72 72 72z";

export const SIXTEENTH_REST_PATH =
  "M66 -500l101 327c-34 -12 -70 -23 -106 -23c-46 0 -87 33" +
  " -87 79c0 40 32 72 72 72c25 0 49 -15 57 -39c10 -28 5" +
  " -59 34 -59c16 0 55 51 60 68l46 151c-34 -12 -68 -22" +
  " -104 -22c-46 0 -87 33 -87 79c0 40 33 72 73 72c25 0" +
  " 48 -15 56 -39c10 -28 5 -59 34 -59c15 0 50 49 57 63" +
  "c6 12 23 12 28 0l-179 -670c-8 -7 -17 -10 -27 -10s-20" +
  " 3 -28 10z";

export const EIGHTH_REST_PATH =
  "M72 -250l117 326c-34 -12 -69 -22 -105 -22c-46 0 -87 33" +
  " -87 79c0 40 33 72 73 72c25 0 48 -15 56 -39c10 -28 6" +
  " -59 35 -59c16 0 54 48 61 63c6 12 23 12 28 0l-123 -420" +
  "c-8 -7 -17 -10 -27 -10s-20 3 -28 10z";

export const QUARTER_REST_PATH =
  "M-23 -116c0 28 11 42 40 42c33 0 78 -13 119 -31l-132 158" +
  "c-7 9 -10 17 -10 25c0 34 50 66 87 99c25 22 37 52 37 83" +
  "c0 24 -8 49 -25 69l-35 42c-3 3 -4 7 -4 10c0 9 9 15 17" +
  " 15c4 0 8 -1 11 -5l151 -180c7 -9 10 -17 10 -25c0 -34" +
  " -50 -66 -87 -99c-25 -22 -37 -52 -37 -83c0 -24 7 -49" +
  " 24 -69l84 -99c3 -3 4 -7 4 -10c0 -9 -8 -16 -16 -16" +
  "c-4 0 -9 2 -12 6c-18 21 -63 38 -97 38c-41 0 -53 -26" +
  " -53 -67c0 -35 11 -74 28 -94c5 -6 0 -13 -6 -13c-2 0" +
  " -4 0 -6 2c-45 54 -92 148 -92 202z";

export const HALF_REST_PATH =
  "M365 0h-355c-6 0 -10 4 -10 10v136c0 6 4 10 10 10h355" +
  "c6 0 10 -4 10 -10v-136c0 -6 -4 -10 -10 -10z";

export const WHOLE_REST_PATH =
  "M365 -156h-355c-6 0 -10 4 -10 10v136c0 6 4 10 10 10h355" +
  "c6 0 10 -4 10 -10v-136c0 -6 -4 -10 -10 -10z";
